<div class="cads-currency-amount-input">
  <div
    class="cads-currency-amount-input__hero"
    [class.cads-currency-amount-input__hero--compact]="_isCompact()"
    [class.cads-currency-amount-input__hero--error]="_hasError()"
  >
    @if (_showEmptyPlaceholder()) {
      <span class="cads-currency-amount-input__placeholder" aria-hidden="true">
        {{ _emptyPlaceholderDisplay() }}
      </span>
    }
    <input
      #amountInput
      class="cads-currency-amount-input__input"
      [class.cads-currency-amount-input__input--placeholder]="_showEmptyPlaceholder()"
      type="text"
      inputmode="decimal"
      [attr.id]="_inputId()"
      [attr.aria-label]="_ariaLabel()"
      [attr.aria-invalid]="_hasError() ? true : null"
      [attr.aria-describedby]="_showCaption() ? _captionId() : null"
      [disabled]="_disabled()"
      (focus)="_onFocus()"
      (input)="_onInput()"
      (keydown)="_onKeydown()"
      (blur)="_onBlur()"
    />
  </div>

  @if (_showCaption()) {
    <p
      class="cads-currency-amount-input__caption"
      [class.cads-currency-amount-input__caption--error]="_hasError()"
      [id]="_captionId()"
      [attr.role]="_hasError() ? 'alert' : null"
    >
      {{ _captionText() }}
    </p>
  }

  @if (_quickOptions().length > 0) {
    <div class="cads-currency-amount-input__chips">
      @for (option of _quickOptions(); track $index; let i = $index) {
        <cads-chip-button
          [config]="_chipConfig(option, i)"
          (tapped)="_onChipTap(option, i)"
        />
      }
    </div>
  }
</div>
